module.exports = __webpack_public_path__ + "img/nav-icon-4.b5bee3fb.png";